import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../i18n";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.split("-")[0] || "en";

  useEffect(() => {
    document.documentElement.lang = current;
    document.documentElement.dir = current === "ur" ? "rtl" : "ltr";
  }, [current]);

  const change = (code) => i18n.changeLanguage(code);

  return (
    <div className={`inline-flex items-center gap-1.5 ${compact ? "" : "bg-white border border-slate-200 rounded-xl p-1"}`} data-testid="language-switcher">
      {compact && <Globe className="w-4 h-4 text-slate-400 mx-1" />}
      <select
        data-testid="language-select"
        value={current}
        onChange={(e) => change(e.target.value)}
        className={`bg-transparent text-sm outline-none ${compact ? "border border-slate-300 rounded-lg px-2 py-1" : "px-2 py-1"}`}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </div>
  );
}
